module.exports = __webpack_public_path__ + "static/how-to-build-a-data-driven-company-d27e0f08a171fe8acf21ec1f31388b52.png";